import React from 'react';
import { FiDownload, FiEye } from 'react-icons/fi';

const ReceiptViewer = ({ base64String }) => {
  if (!base64String) {
    return <span className="text-gray-400 text-sm">No receipt available</span>;
  }

  const isPDF = base64String.startsWith("JVBER");
  const mimeType = isPDF ? 'application/pdf' : 'image/jpeg';
  const fileExtension = isPDF ? 'pdf' : 'jpg';

  return (
    <div className="mt-2">
      <div className="flex space-x-4">
        <a
          href={`data:${mimeType};base64,${base64String}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 text-sm"
        >
          <FiEye className="mr-1" /> View Receipt
        </a>
        <a
          href={`data:${mimeType};base64,${base64String}`}
          download={`fuel_receipt_${new Date().getTime()}.${fileExtension}`}
          className="inline-flex items-center text-blue-600 hover:text-blue-800 text-sm"
        >
          <FiDownload className="mr-1" /> Download
        </a>
      </div>
      
      {!isPDF && (
        <div className="mt-2">
          <img 
            src={`data:image/jpeg;base64,${base64String}`} 
            alt="Receipt preview"
            className="max-h-40 border rounded"
          />
        </div>
      )}
    </div>
  );
};

export default ReceiptViewer;